var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnhide = function SvgUnhide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.919 10.168a2.252 2.252 0 1 1-3.086-3.085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.498 12.747A7.404 7.404 0 0 1 9 14.252a7.093 7.093 0 0 1-6.418-3.817 3.242 3.242 0 0 1 0-2.87 6.679 6.679 0 0 1 2.834-2.9M15.32 10.6c.03-.056.07-.107.098-.165a3.242 3.242 0 0 0 0-2.87A7.093 7.093 0 0 0 9 3.748c-.169 0-.333.022-.499.033M15.753 15.003 2.998 2.246"
  })));
};
export { SvgUnhide as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiOGU3YzgyMjRhOTBiMGM1ZTEzZjdlNjM3NGY0ZmUzOGMuc3ZnIjs=";